/**
 * Form codes that have a server-side report template registered in the API
 * (FORM_REPORTS in controller/v3/productionFormReport.js). Kept in sync by hand:
 * the consolidated Reports list is keyed on iship_production_form_logs.FORM_CODE
 * and must not offer an export for a form the server cannot render.
 */
export const productionFormReportCodes = [
    'SM-011a',
    'SM-011b',
    'SM-011c',
    'SM-018',
    'SM-019',
    'CVCD-001',
    'DIR-001',
    'NCRI-001',
    'WTS-001',
    'NCR-001',
    'ODR-001',
];

export default productionFormReportCodes;
